"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAddressRejectionReasonEnum = void 0;
var OrderAddressRejectionReasonEnum;
(function (OrderAddressRejectionReasonEnum) {
    OrderAddressRejectionReasonEnum["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    OrderAddressRejectionReasonEnum["OUTSIDE_SERVICE_AREA"] = "OUTSIDE_SERVICE_AREA";
    OrderAddressRejectionReasonEnum["RESTRICTED_AREA"] = "RESTRICTED_AREA";
    OrderAddressRejectionReasonEnum["INCOMPLETE_ADDRESS"] = "INCOMPLETE_ADDRESS";
    OrderAddressRejectionReasonEnum["OTHER_LOCATION_SERVICE_AREA"] = "OTHER_LOCATION_SERVICE_AREA";
    OrderAddressRejectionReasonEnum["SINGLE_WORD_ADDRESS"] = "SINGLE_WORD_ADDRESS";
    OrderAddressRejectionReasonEnum["IMPRECISE_ADDRESS"] = "IMPRECISE_ADDRESS";
    OrderAddressRejectionReasonEnum["RESTRICTED_PLACE_TYPE"] = "RESTRICTED_PLACE_TYPE";
    OrderAddressRejectionReasonEnum["RESTRICTED_KEYWORD"] = "RESTRICTED_KEYWORD";
    OrderAddressRejectionReasonEnum["ERROR"] = "ERROR";
    OrderAddressRejectionReasonEnum["MISSING_FLIGHT_NUMBER"] = "MISSING_FLIGHT_NUMBER";
    OrderAddressRejectionReasonEnum["FLIGHT_NUMBER_VALIDATION_FAILED"] = "FLIGHT_NUMBER_VALIDATION_FAILED";
    OrderAddressRejectionReasonEnum["MANUAL_REJECTION"] = "MANUAL_REJECTION";
})(OrderAddressRejectionReasonEnum || (exports.OrderAddressRejectionReasonEnum = OrderAddressRejectionReasonEnum = {}));
//# sourceMappingURL=order-address-rejection-reason.enum.js.map